import React, { useCallback, useState } from 'react';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

function ForgotPassword() {
  const { requestPasswordReset } = useAuth();
  const [email, setEmail] = useState('');
  const [pending, setPending] = useState(false);
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);

  const submit = useCallback(async (e) => {
    e.preventDefault();
    setError('');
    setSent(false);
    setPending(true);
    try {
      const res = await requestPasswordReset(email);
      if (!res.ok) throw new Error(res?.error?.message || 'Failed to send reset email');
      setSent(true);
    } catch (err) {
      setError(err.message || 'Error');
    } finally {
      setPending(false);
    }
  }, [email, requestPasswordReset]);

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col md={6} lg={5}>
          <h1 className="h3 mb-4">Forgot password</h1>
          {error && <Alert variant="danger">{error}</Alert>}
          {sent && <Alert variant="success">Check your email for the reset link.</Alert>}
          <Form onSubmit={submit}>
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control type="email" value={email} onChange={e => setEmail(e.target.value)} required />
            </Form.Group>
            <Button type="submit" variant="primary" disabled={pending}>Send reset link</Button>
          </Form>
          <div className="mt-3">
            <Link to="/login">Back to login</Link>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default ForgotPassword;



